import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-select-parent-group",
  "use": "icon-select-parent-group-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-select-parent-group\">\n<rect x=\"3\" y=\"4\" width=\"8\" height=\"8\" rx=\"2\" fill=\"currentColor\" />\n<rect x=\"13\" y=\"13\" width=\"6\" height=\"4\" rx=\"1\" stroke=\"currentColor\" stroke-width=\"2\" />\n<path d=\"M7 10V13C7 14.1046 7.89543 15 9 15L12 15\" stroke=\"currentColor\" stroke-width=\"2\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol